module.exports = __webpack_public_path__ + "img/sheriff.9b1d31f1.svg";